<template>
  <customize-header>
    <top-bar class="header" />
    <ym-tabs v-model="tabSelected">
      <template #nav-left>
        <header-back-btn class="header-back-btn" />
      </template>
      <ym-tab name="honour" title="家长口碑">
        <ym-loadmore v-model="loading"
                     :finished="allLoad"
                     @load="fetchData"
        >
          <honour-list :list="list" />
        </ym-loadmore>
      </ym-tab>

      <ym-tab name="reputation" title="专家认可">
        <reputation-list />
      </ym-tab>
    </ym-tabs>
  </customize-header>
</template>

<script>
  import {
    Tabs, Tab, Loadmore, HeaderBackBtn,
  } from '@ymba/ym-ui';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';
  import TopBar from '@/components/TopBar';
  import HonourList from '@/pages/Honour/components/HonourList';
  import ReputationList from '@/pages/Honour/components/ReputationList';
  import getHonourList from '@/services/honour';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageHonour',
    metaInfo: {},
    components: {
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      'ym-loadmore': Loadmore,
      CustomizeHeader,
      TopBar,
      HeaderBackBtn,
      HonourList,
      ReputationList,
    },
    data() {
      return {
        tabSelected: 'honour',
        list: [],
        start: 0,
        loading: false,
        allLoad: false,
      };
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;

        const data = await getHonourList({
          limit: LIMIT,
          start: this.start,
        }, isLoadMore);
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.start = data.start;
        this.list = [...this.list, ...data.list];

        this.loading = false;
      },
    },
    created() {
      this.fetchData();
    },
    beforeRouteUpdate(to, from, next) {
      this.fetchData();
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .header-back-btn {
    position: absolute;
    left: 0;
    top: 0;
  }
</style>
